module.exports = __webpack_public_path__ + "img/ai.ed756926.svg";